import React from 'react'

const TournamentManagement = () => {
  return (
    <div>
      <h1>Tournament Management</h1>
    </div>
  )
}

export default TournamentManagement
